import React, { VFC, useMemo, useCallback } from 'react';
import { batch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { browserName } from 'react-device-detect';

import { resetBridge } from '../../redux/slices/bridgeSlice';
import { setSearchText } from '../../redux/slices/historySlice';
import { reset as resetModal, setModal } from '../../redux/slices/modalSlice';
import { useAppDispatch, useFromChainWalletAddress } from '../../hooks';
import { resetWallet } from '../../redux/slices/walletSlice';
import { logout } from '../../redux/slices/kstadiumSlice';
import { convertToExactAddress } from '../../utils/common';

const DropdownNav: VFC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const fromChainWalletAddress = useFromChainWalletAddress();
  const walletAddress = fromChainWalletAddress
    ? convertToExactAddress(fromChainWalletAddress)
    : ``;
  const addressMasked = useMemo(
    () => walletAddress?.replace(walletAddress.slice(8, -6), `...`),
    [walletAddress],
  );

  const disconnect = useCallback(() => {
    batch(() => {
      dispatch(resetBridge());
      dispatch(resetWallet());
      dispatch(resetModal());
      dispatch(logout());
      window.location.reload();
    });
  }, [dispatch]);

  const searchHistoryWithAddress = useCallback(() => {
    batch(() => {
      dispatch(setSearchText(fromChainWalletAddress));
      history.push(`/history`);
    });
  }, [dispatch, fromChainWalletAddress, history]);

  if (`${browserName}` !== `Chrome`) {
    return (
      <>
        <header className="navbar wow fadeInDown" />
      </>
    );
  }

  return (
    <section className="navbar-section">
      {!fromChainWalletAddress ? (
        <button className="btn btn-primary btn-lg disabled">
          Connect Wallet
        </button>
      ) : (
        <div className="dropdown dropdown-right">
          <button className="btn dropdown-toggle" tabIndex={0}>
            <strong>{addressMasked}</strong>
            <i className="icon icon-caret" />
          </button>
          <ul className="menu">
            <li className="menu-item">
              <a onClick={() => dispatch(setModal(`WalletDetail`))}>Wallet</a>
            </li>
            <li className="menu-item">
              <a onClick={searchHistoryWithAddress}>Transaction</a>
            </li>
            <li className="divider" />
            <li className="menu-item">
              <a onClick={disconnect}>Disconnect</a>
            </li>
          </ul>
        </div>
      )}
    </section>
  );
};

export default DropdownNav;
